<template>
  <div class="social_list">
    <NuxtLink v-if="getSocialById(SocialList.X)" rel="nofollow" target="_blank" :to="getSocialById(SocialList.X)?.url">
      <DefaultIconsSocialX />
    </NuxtLink>
    <NuxtLink v-if="getSocialById(SocialList.THREADS)" rel="nofollow" target="_blank" :to="getSocialById(SocialList.THREADS)?.url">
      <DefaultIconsSocialThreads />
    </NuxtLink>
    <NuxtLink v-if="getSocialById(SocialList.FACEBOOK)" rel="nofollow" target="_blank" :to="getSocialById(SocialList.FACEBOOK)?.url">
      <DefaultIconsSocialFacebook />
    </NuxtLink>
    <NuxtLink v-if="getSocialById(SocialList.INSTAGRAM)" rel="nofollow" target="_blank" :to="getSocialById(SocialList.INSTAGRAM)?.url">
      <DefaultIconsSocialInstagram />
    </NuxtLink>
    <NuxtLink v-if="getSocialById(SocialList.YOUTUBE)" rel="nofollow" target="_blank" :to="getSocialById(SocialList.YOUTUBE)?.url">
      <DefaultIconsSocialYoutube />
    </NuxtLink>
    <NuxtLink v-if="getSocialById(SocialList.DISCORD)" rel="nofollow" target="_blank" :to="getSocialById(SocialList.DISCORD)?.url">
      <DefaultIconsSocialDiscord />
    </NuxtLink>
    <NuxtLink v-if="getSocialById(SocialList.TWITCH)" rel="nofollow" target="_blank" :to="getSocialById(SocialList.TWITCH)?.url">
      <DefaultIconsSocialTwitch />
    </NuxtLink>
    <NuxtLink v-if="getSocialById(SocialList.TWITTER)" rel="nofollow" target="_blank" :to="getSocialById(SocialList.TWITTER)?.url">
      <DefaultIconsSocialX />
    </NuxtLink>
    <NuxtLink v-if="getSocialById(SocialList.LINKEDIN)" rel="nofollow" target="_blank" :to="getSocialById(SocialList.LINKEDIN)?.url">
      <DefaultIconsSocialLinkedin />
    </NuxtLink>
    <NuxtLink v-if="getSocialById(SocialList.TELEGRAM)" rel="nofollow" target="_blank" :to="getSocialById(SocialList.TELEGRAM)?.url">
      <DefaultIconsSocialTelegram />
    </NuxtLink>
    <NuxtLink v-if="getSocialById(SocialList.TIKTOK)" rel="nofollow" target="_blank" :to="getSocialById(SocialList.TIKTOK)?.url">
      <DefaultIconsSocialTiktok />
    </NuxtLink>
    <NuxtLink v-if="getSocialById(SocialList.POGTV)" rel="nofollow" target="_blank" :to="getSocialById(SocialList.POGTV)?.url">
      <DefaultIconsSocialPogtv />
    </NuxtLink>
    <NuxtLink v-if="getSocialById(SocialList.YOURADIO)" rel="nofollow" target="_blank" :to="getSocialById(SocialList.YOURADIO)?.url" aria-label="Rádio Mateřídouška na Youradio" title="Rádio Mateřídouška na Youradio">
      <DefaultIconsSocialRadio />
    </NuxtLink>
  </div>
</template>
<script setup lang="ts">
import {SocialList} from "~/libs/constants/SocialList"
import type SocialItem from "~/libs/interfaces/SocialItem"
import type {PropType} from "vue"

const props = defineProps({
  items: {type: Array as PropType<SocialItem[]>, required: true}
})

const getSocialById = (id: SocialList) => {
  if (props.items && props.items.length > 0) {
    return props.items && props.items?.find((item) => item.id === id)
  }
}
</script>